import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import SectionHeading from '../../ui/SectionHeading';

const ContactSection = () => {
  const contactInfo = [
    {
      icon: FaMapMarkerAlt,
      title: 'Office',
      details: ['Caishen Capital Ltd.', 'Govant Building, BP 1276, Port Vila', 'Efate, Vanuatu']
    },
    {
      icon: FaEnvelope,
      title: 'Email',
      details: ['trading@caishen.capital']
    }
  ];
  
  return (
    <section id="contact" className="section-padding bg-black relative">
      {/* Background gradient */}
      <div className="absolute bottom-0 right-0 translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] rounded-full bg-primary-500/5 blur-[100px] pointer-events-none"></div>
      
      <div className="container-custom relative z-10">
        <SectionHeading
          subtitle="Contact Us"
          title="Let's Connect"
          description="Interested in discussing potential investment opportunities or learning more about our portfolio? Get in touch with our team."
        />
        
        <div className="mt-16 grid lg:grid-cols-1 gap-10">
          {/* Contact Info */}
          <div className="w-full">
            <div className="glass-card-strong p-8 h-full">
              <h3 className="text-2xl font-bold mb-8 text-white">Our Information</h3>
              
              <div className="space-y-10">
                {contactInfo.map((item, index) => (
                  <div
                    key={item.title}
                    className="flex"
                  >
                    <div className="mr-4">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center">
                        <item.icon className="text-primary-400 w-5 h-5" />
                      </div>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2 text-white">{item.title}</h4>
                      {item.details.map((detail, idx) => (
                        <p key={idx} className="text-gray-300">{detail}</p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="mt-12 pt-8 border-t border-gray-800">
                <h4 className="text-xl font-bold mb-4 text-white">Investment Focus</h4>
                <p className="text-gray-300 mb-6">
                  We focus on seed and growth-stage companies in the cyberwarfare, AI, fintech, and hydrocarbon sectors 
                  with innovative technologies and strong growth potential.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;